import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatAmount(amount: number | string) {
  if (amount === null || amount === undefined) {
    return "";
  }
  if (typeof amount === "string") {
    return amount;
  }
  return amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });
}

 export function formatDate(dateString: any) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed in JavaScript
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

export const toCamelCase = (str: string | undefined): string => {
  if (!str) return ""; // Handle undefined or empty input safely

  const words = str.split(" ");

  return words
    .map((word, index) => {
      // If it's the first word and fully uppercase, keep it as is
      if (index === 0 && word === word.toUpperCase()) {
        return word;
      }
      // Otherwise, capitalize the first letter and lowercase the rest
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" "); // Join the words back into a single string
};

// Function to get the truncated text
export const truncateText = (text: string | any[], length: number) => {
  if (text.length > length) {
    return `${text.slice(0, length)}...`;
  }
  return text;
};
